import { render, staticRenderFns } from "./XFilter.vue?vue&type=template&id=22bbdb95"
import script from "./XFilter.vue?vue&type=script&lang=js"
export * from "./XFilter.vue?vue&type=script&lang=js"
import style0 from "./XFilter.vue?vue&type=style&index=0&id=22bbdb95&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports